import { render, staticRenderFns } from "./slideShow.vue?vue&type=template&id=0ef203a9"
import script from "./slideShow.vue?vue&type=script&lang=js"
export * from "./slideShow.vue?vue&type=script&lang=js"
import style0 from "./slideShow.vue?vue&type=style&index=0&id=0ef203a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('/root/workspace/web-company_Yo6Q/components/common/commonImg.vue').default})
